import { useCallback } from "react";
import { usePdfExport } from "../usePdfExport";

export const useFullChartsExport = ({ modalContentRef, filterRowRef, styles, slideButtonSelector }) => {
    const { exportPdf, isExporting } = usePdfExport();

    const buildSummaryRowsForExport = useCallback(() => {
        const summaryContainer = modalContentRef.current.querySelector(`.${styles.fullChartsSummaryScroll}`);
        if (!summaryContainer) return { rows: [], wrapper: null };

        const cards = Array.from(summaryContainer.children);
        const containerWidth = summaryContainer.offsetWidth;
        const minCardWidth = 140;
        const gap = 12;
        const cardsPerRow = Math.max(1, Math.floor(containerWidth / (minCardWidth + gap)));
        const wrapper = document.createElement("div");
        wrapper.style.width = `${containerWidth}px`;
        const rows = [];

        for (let i = 0; i < cards.length; i += cardsPerRow) {
            const row = document.createElement("div");
            row.style.display = "grid";
            row.style.gridTemplateColumns = `repeat(${cardsPerRow}, 1fr)`;
            row.style.gap = `${gap}px`;
            row.style.marginBottom = `${gap}px`;
            row.style.width = "100%";

            const slice = cards.slice(i, i + cardsPerRow);
            slice.forEach(card => {
                const clone = card.cloneNode(true);
                clone.style.width = "100%";
                row.appendChild(clone);
            });

            wrapper.appendChild(row);
            rows.push(row);
        }

        wrapper.style.position = "absolute";
        wrapper.style.left = "-9999px";
        document.body.appendChild(wrapper);

        return { rows, wrapper };
    }, [modalContentRef, styles.fullChartsSummaryScroll]);

    const handleExportPDF = useCallback(async () => {
        if (!modalContentRef.current) return;

        const slideButtons = document.querySelectorAll(slideButtonSelector);
        const exportBtn = filterRowRef.current?.exportButton;
        const fixedHeader = modalContentRef.current.querySelector(`.${styles.fullChartsFixedHeader}`);
        const generalInfos = modalContentRef.current.getElementsByClassName(styles.fullChartsGeneralInfos)[0];
        const chartBlocks = modalContentRef.current.querySelectorAll(`.${styles.fullChartsChartBlock}`);
        const { rows: summaryRows, wrapper } = buildSummaryRowsForExport();

        await exportPdf({
            elements: [fixedHeader, generalInfos, ...summaryRows, ...chartBlocks],
            logoSelector: "div.hdv-logomarca img",
            onBeforeExport: async () => {
                if (exportBtn) exportBtn.style.display = "none";
                if (modalContentRef.current) modalContentRef.current.classList.add(styles.exportMode);
                slideButtons.forEach(btn => btn.style.display = "none");
                await new Promise(resolve => setTimeout(resolve, 300));
            },
            onAfterExport: () => {
                if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
                if (modalContentRef.current) modalContentRef.current.classList.remove(styles.exportMode);
                slideButtons.forEach(btn => btn.style.display = "");
                if (exportBtn) exportBtn.style.display = "inline-flex";
            }
        });
    }, [modalContentRef, filterRowRef, buildSummaryRowsForExport, slideButtonSelector, styles, exportPdf]);

    return { handleExportPDF, isExporting };
};